import { useState } from "react"
import { Checkbox } from "../../../../../components/ui/checkbox"
import { Card } from "../../../../../components/ui/card"
import { ChevronDown, Grid3x3, FileText,Package } from "lucide-react"

import { useModulesStore } from "../../../../../context/useModulesStore"
import { usePromptCategoriesStore } from "../../../../../context/usePromptCategoriesStore" 
import { usePromptsStore } from "../../../../../context/usePromptsStore"
import useLanguage from "../../../../../services/useLanguage";

// // Mock data
// const PROMPT_CATEGORIES = [
//   {
//     id: "cat-1",
//     name: "Creative Writing",
//     description: "Prompts for creative writing and storytelling",
//     prompts: [
//       { id: "prompt-1", name: "Character Development" },
//       { id: "prompt-2", name: "Plot Generation" },
//       { id: "prompt-3", name: "Dialogue Writing" },
//     ],
//   },
//   {
//     id: "cat-2",
//     name: "Academic Research",
//     description: "Research and academic writing prompts",
//     prompts: [
//       { id: "prompt-4", name: "Literature Review" },
//       { id: "prompt-5", name: "Thesis Development" },
//       { id: "prompt-6", name: "Citation Help" },
//     ],
//   },
//   {
//     id: "cat-3",
//     name: "Professional Communication",
//     description: "Business and professional writing",
//     prompts: [
//       { id: "prompt-7", name: "Email Drafting" },
//       { id: "prompt-8", name: "Report Writing" },
//       { id: "prompt-9", name: "Presentation Copy" },
//     ],
//   },
// ]

export function PromptStep({ rights, updateRights }) {
  const { modules, isModulesLoading } = useModulesStore()
  const { promptCategories, isPromptCategoriesLoading } = usePromptCategoriesStore()
  const { prompts, isPromptsLoading } = usePromptsStore()
  const currentLang = useLanguage();

  const [expandedModules, setExpandedModules] = useState(modules.map((m) => m.id))
  const [expandedCategories, setExpandedCategories] = useState(promptCategories.map((c) => c.id))

  if (isModulesLoading || isPromptCategoriesLoading || isPromptsLoading) {
    return <div className="text-muted-foreground">Loading prompts...</div>
  }

  const toggleModule = (moduleId) => {
    setExpandedModules((prev) => (prev.includes(moduleId) ? prev.filter((id) => id !== moduleId) : [...prev, moduleId]))
  }

  const toggleCategory = (categoryId) => {
    setExpandedCategories((prev) =>
      prev.includes(categoryId) ? prev.filter((id) => id !== categoryId) : [...prev, categoryId],
    )
  }

  // const handleCategoryToggle = (categoryId) => {
  //   const category = PROMPT_CATEGORIES.find((c) => c.id === categoryId)
  //   if (!category) return

  //   const allPromptIds = category.prompts.map((p) => p.id)
  //   const isCategorySelected = allPromptIds.every((pId) => rights.prompt_ids.includes(pId))

  //   if (isCategorySelected) {
  //     updateRights({
  //       prompt_category_ids: rights.prompt_category_ids.filter((id) => id !== categoryId),
  //       prompt_ids: rights.prompt_ids.filter((pId) => !allPromptIds.includes(pId)),
  //     })
  //   } else {
  //     updateRights({
  //       prompt_category_ids: [...rights.prompt_category_ids, categoryId],
  //       prompt_ids: [...new Set([...rights.prompt_ids, ...allPromptIds])],
  //     })
  //   }
  // }

  // const handlePromptToggle = (promptId) => {
  //   const isSelected = rights.prompt_ids.includes(promptId)
  //   const newPromptIds = isSelected
  //     ? rights.prompt_ids.filter((id) => id !== promptId)
  //     : [...rights.prompt_ids, promptId]

  //   updateRights({ prompt_ids: newPromptIds })

  //   const updatedCategories = PROMPT_CATEGORIES.filter((cat) => {
  //     const anyCategoryPromptSelected = cat.prompts.some((p) => newPromptIds.includes(p.id))
  //     return anyCategoryPromptSelected
  //   }).map((c) => c.id)

  //   updateRights({ prompt_category_ids: updatedCategories })
  // }

  const handleCategoryToggle = (categoryId) => {
    const category = promptCategories.find((c) => c.id === categoryId)
    if (!category) return

    

    const allPromptIds = prompts.filter(p => p.prompt_category_id === categoryId).map(p => p.id) || []

    const isCategorySelected = allPromptIds.every(
      (pId) => rights.prompts.create.includes(pId) || rights.prompts.read.includes(pId),
    )

    if (isCategorySelected) {
      updateRights({
        prompt_categories: {
          create: rights.prompt_categories.create.filter((id) => id !== categoryId),
          read: rights.prompt_categories.read.filter((id) => id !== categoryId),
          update: rights.prompt_categories.update.filter((id) => id !== categoryId),
          delete: rights.prompt_categories.delete.filter((id) => id !== categoryId),
        },
        prompts: {
          create: rights.prompts.create.filter((pId) => !allPromptIds.includes(pId)),
          read: rights.prompts.read.filter((pId) => !allPromptIds.includes(pId)),
          update: rights.prompts.update.filter((pId) => !allPromptIds.includes(pId)),
          delete: rights.prompts.delete.filter((pId) => !allPromptIds.includes(pId)),
        },
      })
    } else {
      updateRights({
        prompt_categories: {
          create: [...rights.prompt_categories.create, categoryId],
          read: rights.prompt_categories.read,
          update: rights.prompt_categories.update,
          delete: rights.prompt_categories.delete,
        },
        prompts: {
          create: [...new Set([...rights.prompts.create, ...allPromptIds])],
          read: rights.prompts.read,
          update: rights.prompts.update,
          delete: rights.prompts.delete,
        },
      })
    }
  }

  const handlePromptToggle = (promptId) => {
    const isSelected = rights.prompts.create.includes(promptId) || rights.prompts.read.includes(promptId)

    const newPromptIds = isSelected
      ? {
          create: rights.prompts.create.filter((id) => id !== promptId),
          read: rights.prompts.read.filter((id) => id !== promptId),
          update: rights.prompts.update.filter((id) => id !== promptId),
          delete: rights.prompts.delete.filter((id) => id !== promptId),
        }
      : {
          create: [...rights.prompts.create, promptId],
          read: rights.prompts.read,
          update: rights.prompts.update,
          delete: rights.prompts.delete,
        }

    updateRights({ prompts: newPromptIds })

    // Update categories based on prompt selections
    const allPromptIds = [...newPromptIds.create, ...newPromptIds.read, ...newPromptIds.update, ...newPromptIds.delete]
    // const updatedCategories = promptCategories
    //   .filter((cat) => (cat.promptIds || []).some((p) => allPromptIds.includes(p)))
    //   .map((c) => c.id)

    
    const updatedCategories = [...new Set(
      prompts
        .filter(p => allPromptIds.includes(p.id))
        .map(p => p.prompt_category_id)
    )];

    updateRights({
      prompt_categories: {
        create: updatedCategories,
        read: rights.prompt_categories.read,
        update: rights.prompt_categories.update,
        delete: rights.prompt_categories.delete,
      },
    })
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Grid3x3 className="w-5 h-5" />
          Select Prompt Categories & Items
        </h3>
        <p className="text-sm text-muted-foreground mb-6">
          Choose which prompt categories and individual prompts are available to this user
        </p>
      </div>

      {modules.filter((module) => rights.modules.create.includes(module.id) || rights.modules.read.includes(module.id))
      .map((module) => {
        const isModuleExpanded = expandedModules.includes(module.id)
        const moduleCategories = promptCategories.filter((cat) => cat.module_id === module.id)
        
        
        return (
          <Card key={module.id} className="border border-border bg-background overflow-hidden">
            {/* Module Header */}
            <button
              onClick={() => toggleModule(module.id)}
              className="w-full p-4 flex items-start gap-3 hover:bg-muted/30 transition-colors text-left"
            >
              <Package className="w-4 h-4 text-primary flex-shrink-0 mt-1" />
              <div className="flex-1">
                <h4 className="font-semibold text-foreground">{module.name}</h4>
                <p className="text-xs text-muted-foreground mt-1">{moduleCategories.length} categories</p>
              </div>
              <ChevronDown
                className={`w-5 h-5 text-muted-foreground transition-transform flex-shrink-0 ${
                  isModuleExpanded ? "rotate-180" : ""
                }`}
              />
            </button>

            {/* Categories within Module */}
            {isModuleExpanded && (
              <div className="border-t border-border bg-muted/5 p-4 space-y-4">
                {moduleCategories.map((category) => {
                  const isExpanded = expandedCategories.includes(category.id)
                  const categoryPrompts = prompts.filter((p) => p.prompt_category_id === category.id)
                  const selectedPrompts = categoryPrompts.filter(
                    (p) => rights.prompts.create.includes(p.id) || rights.prompts.read.includes(p.id),
                  )
                  const selectedPromptCount = selectedPrompts.length
                  const allPromptsSelected = selectedPromptCount === categoryPrompts.length && categoryPrompts.length > 0
                  const somePromptsSelected = selectedPromptCount > 0 && !allPromptsSelected

                  const isCatSelected = rights.prompt_categories.create.includes(category.id) || rights.prompt_categories.read.includes(category.id)

                  return (
                    <Card key={category.id} className="border border-border bg-background overflow-hidden">
                      {/* Category Header */}
                      <button
                        onClick={() => toggleCategory(category.id)}
                        className="w-full p-4 flex items-start gap-3 hover:bg-muted/30 transition-colors text-left"
                      >
                        <Checkbox
                          checked={allPromptsSelected || somePromptsSelected || isCatSelected}
                          indeterminate={somePromptsSelected}
                          onCheckedChange={() => handleCategoryToggle(category.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-1">
                            <Grid3x3 className="w-4 h-4 text-primary" />
                            <h4 className="font-semibold text-foreground">{category?.title[currentLang]}</h4>
                            {selectedPromptCount > 0 && (
                              <span className="text-xs bg-primary text-primary-foreground px-2 py-1 rounded-full">
                                {selectedPromptCount}/{categoryPrompts.length}
                              </span>
                            )}
                          </div>
                          <p className="text-xs text-muted-foreground">{category?.description[currentLang]}</p>
                        </div>
                        <ChevronDown
                          className={`w-5 h-5 text-muted-foreground transition-transform ${isExpanded ? "rotate-180" : ""}`}
                        />
                      </button>

                      {/* Prompts */}
                      {isExpanded && (
                        <div className="border-t border-border bg-muted/10 p-4 space-y-3">
                          {categoryPrompts.map((prompt) => {
                            const isPromptSelected =
                              rights.prompts.create.includes(prompt.id) || rights.prompts.read.includes(prompt.id)
                            return (
                              <label
                                key={prompt.id}
                                className="flex items-center gap-3 p-3 rounded-md bg-background hover:bg-muted/30 transition-colors cursor-pointer border border-border/50"
                              >
                                <Checkbox
                                  checked={isPromptSelected}
                                  onCheckedChange={() => handlePromptToggle(prompt.id)}
                                />
                                <FileText className="w-4 h-4 text-muted-foreground flex-shrink-0" />
                                <span className="text-sm text-foreground">{prompt?.title[currentLang]}</span>
                              </label>
                            )
                          })}
                        </div>
                      )}
                    </Card>
                  )
                })}
              </div>
            )}
          </Card>
        )
      })}

      {/* {PROMPT_CATEGORIES.map((category) => {
        const isExpanded = expandedCategories.includes(category.id)
        const selectedPrompts = category.prompts.filter((p) => rights.prompt_ids.includes(p.id))
        const selectedPromptCount = selectedPrompts.length
        const allPromptsSelected = selectedPromptCount === category.prompts.length
        const somePromptsSelected = selectedPromptCount > 0 && !allPromptsSelected

        const isIndeterminate = somePromptsSelected

        return (
          <Card key={category.id} className="border border-border bg-background overflow-hidden">
            
            <button
              onClick={() => toggleCategory(category.id)}
              className="w-full p-4 flex items-start gap-3 hover:bg-muted/30 transition-colors text-left"
            >
              <Checkbox
                checked={allPromptsSelected || somePromptsSelected}
                indeterminate={isIndeterminate}
                onCheckedChange={() => handleCategoryToggle(category.id)}
                onClick={(e) => e.stopPropagation()}
              />
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <Grid3x3 className="w-4 h-4 text-primary" />
                  <h4 className="font-semibold text-foreground">{category.name}</h4>
                  {selectedPromptCount > 0 && (
                    <span className="text-xs bg-primary text-primary-foreground px-2 py-1 rounded-full">
                      {selectedPromptCount}/{category.prompts.length}
                    </span>
                  )}
                </div>
                <p className="text-xs text-muted-foreground">{category.description}</p>
              </div>
              <ChevronDown
                className={`w-5 h-5 text-muted-foreground transition-transform ${isExpanded ? "rotate-180" : ""}`}
              />
            </button>

            
            {isExpanded && (
              <div className="border-t border-border bg-muted/10 p-4 space-y-3">
                {category.prompts.map((prompt) => {
                  const isPromptSelected = rights.prompt_ids.includes(prompt.id)
                  return (
                    <label
                      key={prompt.id}
                      className="flex items-center gap-3 p-3 rounded-md bg-background hover:bg-muted/30 transition-colors cursor-pointer border border-border/50"
                    >
                      <Checkbox checked={isPromptSelected} onCheckedChange={() => handlePromptToggle(prompt.id)} />
                      <FileText className="w-4 h-4 text-muted-foreground flex-shrink-0" />
                      <span className="text-sm text-foreground">{prompt.name}</span>
                    </label>
                  )
                })}
              </div>
            )}
          </Card>
        )
      })} */}
    </div>
  )
}
